import { getConfigBySite } from '../../config/sites'
import CategoryPageContainer from './categoryPageContainer'
import SearchPageContainer from './searchPageContainer'
import { hasFeature } from '../../common/utils/features'
import { selectItemCountForCategory } from '../../common/selectors/categories'
import {
  hasSearchPageQueryParams,
  getSearchLocationParams
} from '../../common/utils/location'
import pageExperimentContainer, {
  MapStateToPageComponent
} from './pageExperimentContainer/pageExperimentContainer'

const mapStateToPageComponent: MapStateToPageComponent = (
  state,
  routeMatch
) => {
  const {
    experiments,
    common: { currentSite },
    router: { location }
  } = state

  const locationParams = getSearchLocationParams({
    location,
    routeMatch,
    currentSite,
    experiments
  })

  const itemCount = selectItemCountForCategory(state, locationParams.category)
  const minItemCountForCategoryPage = getConfigBySite(
    currentSite,
    'minimum_items_for_category_page'
  )

  if (hasFeature('categoryRedesign', currentSite, location, experiments)) {
    if (hasSearchPageQueryParams(location.query)) {
      return SearchPageContainer
    } else if (
      !locationParams.category ||
      itemCount > minItemCountForCategoryPage
    ) {
      return CategoryPageContainer
    } else {
      return SearchPageContainer
    }
  }
  return SearchPageContainer
}

const CategoryProxyContainer = pageExperimentContainer(
  [SearchPageContainer, CategoryPageContainer],
  mapStateToPageComponent
)

export default CategoryProxyContainer
